import { Box, Container } from '@mui/material';
import React, { ReactElement } from 'react';

// Styles
const sprites: React.CSSProperties = {
  fontSize: 0,
  display: 'inline-block',
  backgroundImage: 'url("sprite.png")',
  verticalAlign: 'middle',
  border: '0 none',
  backgroundRepeat: 'no-repeat',
  marginLeft: '32px',
  width: '32px',
  height: '32px',
};

const twitter: React.CSSProperties = {
  ...sprites,
  backgroundPosition: '-369px -214px',
};
const linkedin: React.CSSProperties = {
  ...sprites,
  backgroundPosition: '-369px -118px',
};
const instagram: React.CSSProperties = {
  ...sprites,
  backgroundPosition: '-369px -70px',
};

const outerBox: React.CSSProperties = {
  padding: '48px',
  paddingTop: '80px',
  paddingBottom: '54px',
  backgroundColor: '#112345',
  marginLeft: '-8px',
  marginRight: '-8px',
  marginTop: '10px',
  marginBottom: '-8px'
};

const links: React.CSSProperties = {
  color: '#FFFFFF',
  cursor: 'pointer',
  display: 'block',
  fontFamily: '"Lato", sans-serif',
  fontSize: '12px',
  lineHeight: '30px',
  whiteSpace: 'nowrap',
  paddingLeft: '8px',
  textDecoration: 'none',
};

const innerDiv: React.CSSProperties = {
  border: '0px solid rgba(255,255,255, .2)',
  marginTop: '8px',
  paddingTop: '8px',
  borderTopWidth: '1px',
};

export function Footer(): ReactElement {
  return (
    <Container maxWidth={false} disableGutters>
      <Box style={outerBox} sx={{ textAlign: { xs: 'center', lg: 'right' } }}>
        <div>
          <a style={links} href="https://www.fredhutch.org/en/util/terms-privacy.html">Terms of Use &amp; Privacy Policy</a>
          <a style={links} href="https://www.fredhutch.org/en/about/about-the-hutch/accountability-impact.html">Accountability &amp; Impact</a>
          <a style={links} href="https://www.fredhutch.org/en/util/conflict-of-interest.html">Conflict of Interest</a>
          <a style={links} href="https://viz.fredhutch.org/contact/">Contact Us</a>
        </div>
        <div style={innerDiv}>
          <div style={{ marginTop: '10px', marginBottom: '10px' }}>
            <Box sx={{ float: { xs: 'none', lg: 'left' }, marginBottom: { xs: '16px', lg: '45px' } }}>
              <img src="/kincyte/dvc-logo-teal.png" style={{ height: '44px' }} alt="logo" />
            </Box>
            <a style={twitter} href="https://twitter.com/FHDataViz" target="_blank" rel="noopener noreferrer"><span className="visually-hidden">Twitter</span></a>
            <a style={linkedin} href="https://www.linkedin.com/company/fhdataviz" target="_blank" rel="noopener noreferrer"><span className="visually-hidden">LinkedIn</span></a>
            <a style={instagram} href="https://www.instagram.com/fhdataviz/" target="_blank" rel="noopener noreferrer"><span className="visually-hidden">Instagram</span></a>
          </div>
        </div>
      </Box>
    </Container>
  );
}
